// Mirrors the Happy Hour site's hero: the photo at full width with the button
// straddling its bottom edge.
.hero {
    position: relative;
}

// The phone crop is 1000×344; desktop is 2160×724, capped so the button stays
// on screen when the page loads, and never trimmed past 80% of its height.
.photo {
    aspect-ratio: 1000 / 344;
    display: block;
    height: auto;
    object-fit: cover;
    width: 100%;

    @media (min-width: 769px) {
        aspect-ratio: 2160 / 724;
        max-height: max(calc(100svh - 143px), 27vw);
        object-position: top;
    }
}

.cta {
    bottom: 0;
    left: 50%;
    position: absolute;
    transform: translate(-50%, 50%);
    z-index: 2;
}
